import { useMutation } from "@tanstack/react-query";
import { queryClient } from "@/queryClient";
import {
  getPaperBillFile,
  initiatePayment,
  updatePaymentTaxCollectorType,
} from "./services";

export const useUpdatePaymentTaxCollectorTypeMutation = () =>
  useMutation({
    mutationKey: ["payment", "selectedTaxCollectorType"],
    mutationFn: updatePaymentTaxCollectorType,
    onSuccess: async () => {
      await queryClient.invalidateQueries({
        queryKey: ["payment", "taxCollectorTypes"],
      });
    },
  });

export const useInitiatePaymentMutation = () =>
  useMutation({
    mutationFn: initiatePayment,
  });

export const useGetPaperBillFileMutation = () =>
  useMutation({
    mutationFn: getPaperBillFile,
  });
